import { todayIsoDate } from '../components/PolicyStartDateField';

/** Shape stored in sessionStorage when renters form is completed while logged out. */
export type StoredRentersFormData = {
  insuranceType?: string;
  zipCode?: string;
  streetAddress?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country?: string;
  safetyFeatures?: string[];
  buildingType?: string;
  hasExistingRentersInsurance?: string;
  hasRoommates?: string;
  roommateCount?: string | number;
  personalLiabilityLimit?: string | number;
  hasHighValueItems?: string;
  referralCode?: string;
  policyStartDate?: string;
  leadId?: number;
};

/** Build API body for POST /insurance/request (matches InsuranceFormPage submit). */
export function buildRentersInsuranceRequestPayload(form: StoredRentersFormData) {
  const personalLiability =
    form.personalLiabilityLimit === '' || form.personalLiabilityLimit == null
      ? undefined
      : Number(form.personalLiabilityLimit);

  const roommateCount =
    form.roommateCount === '' || form.roommateCount == null
      ? 0
      : Number(form.roommateCount);

  return {
    insuranceType: form.insuranceType || 'renters',
    zipCode: form.zipCode,
    streetAddress: form.streetAddress,
    addressLine2: form.addressLine2,
    city: form.city,
    state: form.state,
    country: form.country,
    safetyFeatures: form.safetyFeatures || [],
    buildingType: form.buildingType,
    hasExistingRentersInsurance: form.hasExistingRentersInsurance === 'yes',
    hasRoommates: roommateCount > 0,
    personalLiabilityLimit: personalLiability,
    roommateCount,
    hasHighValueItems: form.hasHighValueItems === 'yes',
    referralCode: form.referralCode?.trim() || undefined,
    policyStartDate: form.policyStartDate?.trim() || todayIsoDate(),
    ...(form.leadId != null ? { leadId: form.leadId } : {}),
  };
}
